/* eslint-disable camelcase */
export const AUTH_TYPE_KEYS: Record<string, string> = {
  none: 'data.authTypeNone',
  oauth_client_credentials: 'data.authTypeOauthClientCredentials',
  client_certificate: 'data.authTypeClientCertificate',
  custom_headers: 'data.authTypeCustomHeaders',
  password: 'data.authTypePassword',
  auth0: 'data.authTypeAuth0',
}
